import React from 'react';
import { BunkeringEvent } from 'src/types/ViewModel/Bunkering/BunkeringEvent';
import { DebunkeringItemWrapper } from '../../Bunkering.styles';
import { FuelType } from 'src/types/ViewModel/Bunkering/FuelType';
import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';

interface DebunkeringListItemProps {
    debunkeringEvent: BunkeringEvent;
    selected: boolean;
    onSelectBunkeringEvent: (id: string) => void;
}

const DebunkeringListItem: React.FC<DebunkeringListItemProps> = ({ debunkeringEvent, selected, onSelectBunkeringEvent }) => {
    return (
        <DebunkeringItemWrapper selected={selected} onClick={() => onSelectBunkeringEvent(debunkeringEvent.id)}>
            <td>New Debunkering event: {FuelType[debunkeringEvent.fuelType]}</td>
            <td />
            <td>{prettifyDateTimeHHmm(debunkeringEvent.bunkeringDateTimeLocal)}</td>
            <td>{debunkeringEvent.voyageNumber}</td>
        </DebunkeringItemWrapper>
    );
};

export default DebunkeringListItem;
